import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import StoryCluster, { clusterFromBackend } from "./redesign/StoryCluster";
import { SectionHeader } from "./redesign/Sections";

const CategoryPage = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [clusters, setClusters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setClusters([]);

    axios
      .get(`${process.env.REACT_APP_API_URL}/category/${category}`)
      .then((response) => {
        if (response.data && typeof response.data === "object") {
          setClusters(Object.entries(response.data));
        } else {
          setClusters([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(`Error fetching data for category ${category}:`, err);
        setError(err);
        setLoading(false);
        if (err.response && err.response.status === 404) {
          setTimeout(() => navigate("/"), 3000);
        }
      });
  }, [category, navigate]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: "40%" }} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-card border border-line bg-surface p-6">
        <h2 className="font-head text-[20px] font-bold text-ink">
          Kategoria nuk u gjet
        </h2>
        <p className="mt-2 text-[14px] text-sub">
          Kategoria "{category}" nuk është e disponueshme. Do të ridrejtoheni
          tek faqja kryesore pas pak…
        </p>
        <p className="mt-3">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
            className="font-head font-semibold text-brand hover:underline"
          >
            Klikoni këtu për t'u kthyer tani
          </a>
        </p>
      </div>
    );
  }

  if (clusters.length === 0) {
    return (
      <div className="rounded-card border border-line bg-surface p-6">
        <h1 className="font-head text-[24px] font-bold text-ink">{category}</h1>
        <p className="mt-2 text-[14px] text-sub">
          Nuk ka grupe lajmesh të disponueshme në këtë kategori për momentin.
        </p>
        <Link
          to="/"
          className="mt-3 inline-block font-head font-semibold text-brand hover:underline"
        >
          ← Kthehu në Kryefaqe
        </Link>
      </div>
    );
  }

  const [head, ...rest] = clusters;
  const headCluster = clusterFromBackend(category, head[0], head[1]);

  return (
    <div>
      <SectionHeader title={category} />

      <StoryCluster
        cluster={headCluster}
        variant="hero"
        detailHref={`/category/${category}/cluster/${head[0]}`}
      />

      <div className="mt-4">
        {rest.map(([clusterId, clusterData]) => {
          if (!clusterData?.articles?.length) return null;
          return (
            <StoryCluster
              key={clusterId}
              cluster={clusterFromBackend(category, clusterId, clusterData)}
              variant="compact"
              detailHref={`/category/${category}/cluster/${clusterId}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CategoryPage;
